import authInitializer from "modules/auth/authInitializer";
import firebaseInitializer from "common/firebase/firebaseInitializer";

export default [firebaseInitializer, authInitializer];
